import TaTravelerModal from './TaTravelerModal'

export default TaTravelerModal
